export default {
  props: {
    color: {
      type: [String],
      default: null
    },    
    disabled: {
      type: Boolean,
      default: false 
    }, 
    loading: {
      type: Boolean,
      default: false 
    }, 
    xSmall: {
      type: Boolean,
      default: false 
    },
    small: {
      type: Boolean,
      default: false 
    },
    block : {
      type: Boolean,
      default: true 
    }, 
    rounded : {
      type: Boolean,
      default: false 
    }, 
    large : {
      type: Boolean,
      default: false 
    }, 
    icon : {
      type: Boolean,
      default: false 
    },
  },

}